import { createApi } from '@reduxjs/toolkit/query/react';
import { CHANGE_PASSWORD } from 'config/apiPaths';
import { setUserData } from "store/slices/authSlice";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/account",
  }),
  tagTypes: ["Profile"],
  endpoints: (builder) => ({
    verifyActivationToken: builder.query({
      query: (token) => ({
        url: `/verification/${token}`
      }),
      transformResponse: (response) => {
        return response?.data;
      }
    }),
    activateAccount: builder.mutation({
      query: ({ payload, token }) => ({
        url: `/verify/email/${token}`,
        method: 'POST',
        data: payload,
      })
    }),
    forgotPassword: builder.mutation({
      query: (payload) => ({
        url: "/forgot/password",
        method: 'POST',
        data: payload,
      })
    }),
    resetPassword: builder.mutation({
      query: ({ payload, token }) => ({
        url: `/update/password/${token}`,
        method: 'POST',
        data: payload,
      })
    }),
    getProfile: builder.query({
      query: () => ({
        url: `/profile`,
        method: 'GET',
      }),
      providesTags: ["Profile"],
      transformResponse: (response) => {
        return response?.data;
      },
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          let response = await queryFulfilled;
          const userData = response?.data;
          dispatch(setUserData({
            id: userData?.id,
            firstname: userData?.firstname,
            lastname: userData?.lastname,
            username: userData?.username,
            phone: userData?.phone,
            email: userData?.email,
            profile_picture: userData?.therapist_detail?.profile_picture,
            role_type: userData?.therapist_detail?.type,
            therapist_designation: userData?.therapist_detail?.therapist_designation,
            therapist_discipline: userData?.therapist_detail?.therapist_discipline,
            signature_img: userData?.therapist_detail?.signature_img,
            termsAndConditionsStatus: userData?.termsAndConditionsStatus,
            pending_policies_count: userData?.pending_policies_count,
            assigned_client_category: userData?.therapist_detail?.assigned_client_category,
            email_signature: userData?.therapist_detail?.email_signature,
          }))
        } catch (err) {
          throw err;
        }
      },
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `/profile/update_v2`,
        method: 'PUT',
        data
      }),
      invalidatesTags: ["Profile"]
    }),
    sendUpdateEmailOtp: builder.mutation({
      query: (data) => ({
        url: `/email/otp`,
        method: 'PUT',
        data
      }),
    }),
    verifyEmailOtp: builder.mutation({
      query: (data) => ({
        url: `/verify/email`,
        method: 'PUT',
        data
      }),
      invalidatesTags: ["Profile"]
    }),
    checkUsername: builder.mutation({
      query: (data) => ({
        url: `/find/username`,
        method: 'PUT',
        data
      })
    }),
    acceptTerms: builder.mutation({
      query: (data) => ({
        url: `/accept-terms`,
        method: 'POST',
        data
      }),
      invalidatesTags: ["Profile"]
    }),
    changePassword: builder.mutation({
      query: ({data}) => ({
        url: CHANGE_PASSWORD,
        method: 'PUT',
        data
      }),
      invalidatesTags: ["changePassword"]
    }),
  }),
});

export const {
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyActivationTokenQuery,
  useActivateAccountMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useSendUpdateEmailOtpMutation,
  useVerifyEmailOtpMutation,
  useCheckUsernameMutation,
  useAcceptTermsMutation,
  useChangePasswordMutation
} = authApi;
